// import React from "react";
// import Navbar from "./Navbar";
// import Footer from "./Footer";
// import FadeInOnScroll from "./FadeInOnScroll"; // 名字随便，但首字母要大写
// import FadeInCard from "./FadeInCard";
// export default function OurTeam() {
//   const teamMembers = [
//     {
//       name: "MR. NIU LIMING",
//       title: "Director & Int. CEO",
//       img: "/team/team1.png",
//       color: "from-[#d6b8ff]/60 to-[#f0e6ff]/60",
//       highlight: "bg-[#8a6be9]",
//       description: `Mr Niu Liming is currently the Director and Interim CEO of AI Nova.
//       Mr Niu has more than 20 years of management and investment experience, mainly in M&A,
//       corporate restructuring, project financing, pre-IPO investment, private equity investment,
//       technology transfer, and R&D areas.`,
//     },
//     {
//       name: "MS. KRISTY TAN",
//       title: "Director",
//       img: "/team/team2.png",
//       color: "from-[#e2d3ff]/60 to-[#f8f0ff]/60",
//       highlight: "bg-[#b18fff]",
//       description: `Kristy serves as the Director of AI NOVA, bringing over 15 years of experience in
//       management, corporate advisory, and cross-border investment. She is also the Managing Director of
//       a Singapore-based corporate advisory firm, where she oversees strategic deals in South East Asia.
//       Kristy has been involved in multiple sectors including banking, real estate, and TMT.`,
//     },
//     {
//       name: "MR. TIM GOODCHILD",
//       title: "Director",
//       img: "/team/team3.png",
//       color: "from-[#e3d7ff]/60 to-[#f8f0ff]/60",
//       highlight: "bg-[#9b80ff]",
//       description: `Tim was formerly the Head of Strategic Affairs at StarHub Ltd. He has also worked
//       for the Infocomm Media Development Authority, France Telecom, Millicom International Cellular Ltd,
//       and Telecom Corporation of New Zealand Ltd. He has more than 30 years of experience in regulation,
//       compliance, and Government relations across the Asia-Pacific region.`,
//     },
//     {
//       name: "MR. GIULIO DORRUCCI",
//       title: "COO",
//       img: "/team/team4.png",
//       color: "from-[#e3d7ff]/60 to-[#f8f0ff]/60",
//       highlight: "bg-[#a97cff]",
//       description: `Giulio is an entrepreneur with over 30 years of experience establishing and leading
//       global businesses. He received numerous international accolades including the Asia Pacific
//       Entrepreneurship Award and the Spirit of Enterprise Award, and was also named one of the Best Men
//       of the Year by ADAsia Magazine.`,
//     },
//     {
//       name: "MR. WOO KWEK KIONG",
//       title: "CFO",
//       img: "/team/team5.png",
//       color: "from-[#e2d3ff]/60 to-[#f8f0ff]/60",
//       highlight: "bg-[#8c73e9]",
//       description: `Kwek Kiong Woo brings extensive experience in business management, corporate finance,
//       and leadership across Asia. He has led multi-million-dollar financing exercises including bond
//       issuances and IPO initiatives. Previously served as CFO at listed companies such as STATS ChipPAC
//       and ASTI Holdings.`,
//     },
//     {
//       name: "MR. ZU HAO JIE",
//       title: "VP Data Centre & Partnerships",
//       img: "/team/team6.png",
//       color: "from-[#e3d7ff]/60 to-[#f8f0ff]/60",
//       highlight: "bg-[#8a6be9]",
//       description: `Zu Hao Jie is a veteran in digital infrastructure with over 21 years of experience.
//       He currently serves as Senior Vice President at Huaton Cloud Data and has led major projects
//       including Alibaba’s Zhejiang Cloud Base and the Hangzhou Government Cloud.`,
//     },
//     {
//       name: "MR. ANDY CHING",
//       title: "Regional Project Manager",
//       img: "/team/team7.png",
//       color: "from-[#e2d3ff]/60 to-[#f8f0ff]/60",
//       highlight: "bg-[#7c60e8]",
//       description: `Andy Ching brings over 20 years of experience leading IT and cybersecurity projects
//       across the Asia-Pacific. He has held leadership roles at Ensign InfoSecurity, Marina Bay Sands, NCS,
//       T-Systems, and IHG, focusing on infrastructure and data center operations.`,
//     },
//   ];

//   return (
//     <>
//       {/* 如果你有 Navbar / Footer 就在外层包起来 */}
//       {/* <Navbar /> */}

//       <section className="relative overflow-hidden bg-gradient-to-br from-purple-50 via-white to-purple-100 text-[#1e0b44] py-14 px-4 sm:py-20 sm:px-6 md:px-10">
//         <div className="max-w-6xl mx-auto text-center mb-10 sm:mb-14">
//           <FadeInOnScroll>
//           <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-3 sm:mb-4 bg-gradient-to-r from-[#6a2dd9] to-[#9a8dfc] bg-clip-text text-transparent">
//             OUR TEAM
//           </h2>
//           <p className="max-w-2xl mx-auto text-md sm:text-md text-[#5e4ca8]">
//             Meet the leadership team driving AI NOVA&apos;s innovation and
//             growth.
//           </p>
//           </FadeInOnScroll>
//         </div>

//         {/* 卡片布局：手机 1 列、平板 2 列、桌面 3 列 */}
//         <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
//           {teamMembers.map((member, index) => (
//             <FadeInCard key={member.name}>
//             <div
//               key={member.name}
//               className={`
//                 bg-gradient-to-br ${member.color}
//                 rounded-2xl shadow-[0_10px_22px_rgba(15,23,42,0.15)]
//                 p-5 sm:p-6
//                 flex flex-col items-center
//                 transition-all duration-300
//                 hover:scale-[1.02] hover:shadow-[0_14px_32px_rgba(15,23,42,0.45)]
//                 max-w-sm w-full mx-auto cursor-pointer
//               `}
//             >
//               {/* 头像 - 手机略小 */}
//               <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-full overflow-hidden border-[4px] border-white shadow-[0_0_20px_rgba(138,79,255,0.3)] mb-4">
//                 <img
//                   src={member.img}
//                   alt={member.name}
//                   className="object-cover w-full h-full"
//                 />
//               </div>

//               {/* 姓名 & 职位 */}
//               <div
//                 className={`
//                   text-white px-3 sm:px-4 py-1 mb-3 sm:mb-4
//                   font-bold uppercase rounded-md text-[0.7rem] sm:text-xs md:text-sm
//                   ${member.highlight} shadow text-center
//                   // 手机上允许换行，避免太挤
//                 `}
//               >
//                 {member.name}, {member.title}
//               </div>

//               {/* 简介：小屏字体更小一点并改为左对齐更易读 */}
//               <p className="text-[#2a0f4c]/90 text-xs sm:text-[0.9rem] leading-relaxed text-left text-justify">
//                 {member.description}
//               </p>
//             </div>
//             </FadeInCard>
//           ))}
//         </div>
//       </section>

//       {/* <Footer /> */}
//     </>
//   );
// }
import React, { useMemo, useState, useRef, useLayoutEffect } from "react";
import FadeInOnScroll from "./FadeInOnScroll2";
import FadeInCard from "./FadeInCard2";

function TeamCard({ member, isOpen, onToggle }) {
  const contentRef = useRef(null);
  const [contentH, setContentH] = useState(0);

  useLayoutEffect(() => {
    if (!contentRef.current) return;
    setContentH(isOpen ? contentRef.current.scrollHeight : 0);
  }, [isOpen, member.description]);

  const toggleSelf = () => onToggle(member.name);

  return (
    <FadeInCard>
      <div
        role="button"
        tabIndex={0}
        onClick={toggleSelf}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggleSelf();
          }
        }}
        className={`
          relative
          bg-gradient-to-br ${member.color}
          rounded-2xl shadow-[0_10px_22px_rgba(15,23,42,0.15)]
          p-5 sm:p-6
          flex flex-col items-center
          transition-all duration-300
          hover:scale-[1.02] hover:shadow-[0_14px_32px_rgba(15,23,42,0.35)]
          w-full
          will-change-transform
          cursor-pointer
          focus:outline-none focus-visible:ring-2 focus-visible:ring-[#9a8dfc]/60
        `}
      >
        {/* + / -（保留外观，但不再“必须点它”） */}
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation(); // 防止触发外层 onClick 二次切换
            toggleSelf();
          }}
          aria-label={isOpen ? "Close description" : "Open description"}
          className={[
            "absolute top-4 right-4 h-7 w-7 rounded-md grid place-items-center",
            "text-white font-bold leading-none",
            "transition-all duration-300 ease-out",
            !isOpen
              ? "bg-[#f06cff] shadow-[0_10px_18px_rgba(240,108,255,0.35)] hover:scale-110 hover:-translate-y-0.5 hover:shadow-[0_14px_22px_rgba(240,108,255,0.55)]"
              : "bg-[#5b2e91] shadow-[0_10px_18px_rgba(91,46,145,0.35)] hover:scale-[1.06] hover:shadow-[0_16px_26px_rgba(91,46,145,0.55)]",
          ].join(" ")}
        >
          {isOpen ? "–" : "+"}
        </button>

        {/* 头像 */}
        <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-full overflow-hidden border-[4px] border-white shadow-[0_0_20px_rgba(138,79,255,0.3)] mb-4">
          <img
            src={member.img}
            alt={member.name}
            className="object-cover w-full h-full"
            draggable={false}
            onClick={(e) => e.stopPropagation()} // 可选：不想点头像也触发就保留；想点头像也能触发就删掉这行
          />
        </div>

        {/* 名字职位 */}
        <div className="mb-1 text-[0.65rem] sm:text-xs md:text-sm font-semibold uppercase tracking-wide text-[#3b2a6d]">
          {member.title}
        </div>

        {/* 名字（有背景） */}
        <div
          className={`
            text-white px-3 sm:px-4 py-1 mb-3 sm:mb-4
            font-bold uppercase rounded-md text-[0.7rem] sm:text-xs md:text-sm
            ${member.highlight} shadow text-center
          `}
        >
          {member.name}
        </div>

        {/* smooth 展开/收起 */}
        <div
          className={[
            "w-full overflow-hidden",
            "transition-[height,opacity,transform] duration-500",
            "ease-[cubic-bezier(.22,1,.36,1)]",
            isOpen ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-1",
          ].join(" ")}
          style={{ height: contentH }}
        >
          <div ref={contentRef}>
            <p className="pt-1 text-[#2a0f4c]/90 text-xs sm:text-[0.9rem] leading-relaxed text-left text-justify">
              {member.description}
            </p>
          </div>
        </div>
      </div>
    </FadeInCard>
  );
}


export default function OurTeam() {
  const [openName, setOpenName] = useState(null);

  const teamMembers = [
    {
      name: "MR. NIU LIMING",
      title: "Director & Int. CEO",
      img: "/team/team1.png",
      color: "from-[#d6b8ff]/60 to-[#f0e6ff]/60",
      highlight: "bg-[#8a6be9]",
      description: `Mr Niu Liming is currently the Director and Interim CEO of AI Nova.
Mr Niu has more than 20 years of management and investment experience, mainly in M&A,
corporate restructuring, project financing, pre-IPO investment, private equity investment,
technology transfer, and R&D areas.`,
    },
    {
      name: "MS. KRISTY TAN",
      title: "Director",
      img: "/team/team2.png",
      color: "from-[#e2d3ff]/60 to-[#f8f0ff]/60",
      highlight: "bg-[#b18fff]",
      description: `Kristy serves as the Director of AI NOVA, bringing over 15 years of experience in
management, corporate advisory, and cross-border investment. She is also the Managing Director of
a Singapore-based corporate advisory firm, where she oversees strategic deals in South East Asia.
Kristy has been involved in multiple sectors including banking, real estate, and TMT.`,
    },
    {
      name: "MR. TIM GOODCHILD",
      title: "Director",
      img: "/team/team3.png",
      color: "from-[#e3d7ff]/60 to-[#f8f0ff]/60",
      highlight: "bg-[#9b80ff]",
      description: `Tim was formerly the Head of Strategic Affairs at StarHub Ltd. He has also worked
for the Infocomm Media Development Authority, France Telecom, Millicom International Cellular Ltd,
and Telecom Corporation of New Zealand Ltd. He has more than 30 years of experience in regulation,
compliance, and Government relations across the Asia-Pacific region.`,
    },
//     {
//       name: "MR. GIULIO DORRUCCI",
//       title: "COO",
//       img: "/team/team4.png",
//       color: "from-[#e3d7ff]/60 to-[#f8f0ff]/60",
//       highlight: "bg-[#a97cff]",
//       description: `Giulio is an entrepreneur with over 30 years of experience establishing and leading
// global businesses. He received numerous international accolades including the Asia Pacific
// Entrepreneurship Award and the Spirit of Enterprise Award, and was also named one of the Best Men
// of the Year by ADAsia Magazine.`,
//     },
    {
      name: "MR. WOO KWEK KIONG",
      title: "CFO",
      img: "/team/team5.png",
      color: "from-[#e2d3ff]/60 to-[#f8f0ff]/60",
      highlight: "bg-[#8c73e9]",
      description: `Kwek Kiong Woo brings extensive experience in business management, corporate finance,
and leadership across Asia. He has led multi-million-dollar financing exercises including bond
issuances and IPO initiatives. Previously served as CFO at listed companies such as STATS ChipPAC
and ASTI Holdings.`,
    },
    {
      name: "MR. ZU HAO JIE",
      title: "VP Data Centre & Partnerships",
      img: "/team/team6.png",
      color: "from-[#e3d7ff]/60 to-[#f8f0ff]/60",
      highlight: "bg-[#8a6be9]",
      description: `Zu Hao Jie is a veteran in digital infrastructure with over 21 years of experience.
He currently serves as Senior Vice President at Huaton Cloud Data and has led major projects
including Alibaba’s Zhejiang Cloud Base and the Hangzhou Government Cloud.`,
    },
    {
      name: "MR. ANDY CHING",
      title: "Regional Project Manager",
      img: "/team/team7.png",
      color: "from-[#e2d3ff]/60 to-[#f8f0ff]/60",
      highlight: "bg-[#7c60e8]",
      description: `Andy Ching brings over 20 years of experience leading IT and cybersecurity projects
across the Asia-Pacific. He has held leadership roles at Ensign InfoSecurity, Marina Bay Sands, NCS,
T-Systems, and IHG, focusing on infrastructure and data center operations.`,
    },
  ];

  const toggle = (name) => setOpenName((prev) => (prev === name ? null : name));

  const columns = useMemo(() => {
    const colCount = 3;
    const cols = Array.from({ length: colCount }, () => []);
    teamMembers.forEach((m, i) => cols[i % colCount].push(m));
    return cols;
  }, [teamMembers]);

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-purple-50 via-white to-purple-100 text-[#1e0b44] py-14 px-4 sm:py-20 sm:px-6 md:px-10">
      <div className="max-w-6xl mx-auto text-center mb-10 sm:mb-14">
        <FadeInOnScroll>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-3 sm:mb-4 bg-gradient-to-r from-[#6a2dd9] to-[#9a8dfc] bg-clip-text text-transparent">
            OUR TEAM
          </h2>
          <p className="max-w-2xl mx-auto text-md sm:text-md text-[#5e4ca8]">
            Meet the leadership team driving AI NOVA&apos;s innovation and
            growth.
          </p>
        </FadeInOnScroll>
      </div>

      <div className="max-w-6xl mx-auto">
        {/* 手机：1列 */}
        <div className="flex flex-col gap-6 sm:hidden">
          {teamMembers.map((m) => (
            <TeamCard
              key={m.name}
              member={m}
              isOpen={openName === m.name}
              onToggle={toggle}
            />
          ))}
        </div>

        {/* 平板：2列（独立列） */}
        <div className="hidden sm:flex lg:hidden gap-6 sm:gap-8">
          <div className="flex-1 flex flex-col gap-6 sm:gap-8">
            {teamMembers
              .filter((_, i) => i % 2 === 0)
              .map((m) => (
                <TeamCard
                  key={m.name}
                  member={m}
                  isOpen={openName === m.name}
                  onToggle={toggle}
                />
              ))}
          </div>
          <div className="flex-1 flex flex-col gap-6 sm:gap-8">
            {teamMembers
              .filter((_, i) => i % 2 === 1)
              .map((m) => (
                <TeamCard
                  key={m.name}
                  member={m}
                  isOpen={openName === m.name}
                  onToggle={toggle}
                />
              ))}
          </div>
        </div>

        {/* 桌面：3列 */}
        <div className="hidden lg:flex gap-6 sm:gap-8">
          {columns.map((col, idx) => (
            <div key={idx} className="flex-1 flex flex-col gap-6 sm:gap-8">
              {col.map((m) => (
                <TeamCard
                  key={m.name}
                  member={m}
                  isOpen={openName === m.name}
                  onToggle={toggle}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
